import anonymousNames from './anonymous-names.json'
import ui from './ui.json'

export default {
  language: 'Español',
  languageTag: 'es',
  ...ui,
  anonymousNames
}
